import PubSub from "underpub-js";

var ListingLogo = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingLogo',
	};

	$.extend(true, this.options, options);

};

ListingLogo.prototype.init = function() {

	var self = this;

};

export default ListingLogo;
